<template >
  <div
    class="form-group formways-component formways-select"
    :class="ctx.customClass"
    v-if="!ctx.hidden"
  >
    <label :for="ctx.key">
      {{ ctx.label }}
      <span v-if="ctx.validate.required" class="text-danger">* </span>
      <i
        v-if="ctx.tooltip"
        class="fa fa-question-circle"
        aria-hidden="true"
        data-toggle="tooltip"
        data-placement="right"
        :title="ctx.tooltip"
      ></i>
    </label>
    <select
      class="form-control"
      :id="ctx.key"
      :required="ctx.validate.required"
      v-model="value"
      :multiple="ctx.multiple"
      :disabled="ctx.disabled"
    >
    </select>
    <small :id="ctx.key + 'Help'" class="form-text text-muted">
      {{ ctx.description }}
    </small>
  </div>
</template>

<script>
import Choices from 'choices.js';
import Axios from 'axios';
import FieldMixin from '../../mixins/FieldMixin';
import '../../../node_modules/choices.js/public/assets/styles/choices.min.css';
import '../../assets/custom.css';
import defaultSchema from './defaultSchema';
import {
  promiseTimeout,
  placeholders,
  addEmptySelectOption
} from '../../utils';

export default {
  name: 'selectComponent',
  mixins: [FieldMixin],
  beforeCreate() {
    this.defaultSchema = defaultSchema;
  },
  async mounted() {
    if (this.ctx.hidden) return;
    const self = this;
    const element = this.$el.querySelector(`#${this.ctx.key}`);
    await this.initFieldValue();
    // initializing the choice js element
    this.select = new Choices(element, {
      placeholderValue: self.ctx.placeholder,
      searchPlaceholderValue: 'Start typing to search the options',
      removeItemButton: true,
      shouldSort: false,
      itemSelectText: ''
    });
    await this.setChoices();
    /**
     * After initialization the value of the fields must be set explicitly
     * to reflect it in the newly initialized ChoiceJs element
     */
    if (this.ctx.dataSrc !== 'url') {
      // For dataSrc = url, this is handled inside this.setChoices() function
      self.select.setChoiceByValue(self.value);
    }
    // To dynamically reload data src url when dependent field value changes
    this.store.eventBus.$on('value-changed', this.dependentValueChanged);
  },
  methods: {
    /**
     * Set choices of select input either using the given values
     * or by calling the url provided.
     */
    async setChoices() {
      switch (this.ctx.dataSrc) {
        case 'values':
          if (this.ctx.multiple === false) {
            // Placeholder for non multi select
            addEmptySelectOption(this.ctx.data.values);
          }
          this.select.setChoices(this.ctx.data.values, 'value', 'label', true);
          break;
        case 'url':
          await this._setChoiceFromURL();
          break;
        default:
          // eslint-disable-next-line
          console.error(`Choices for ${this.ctx.label} is not set properly`);
          break;
      }
    },
    async _setChoiceFromURL() {
      const self = this;
      let url = '';
      await promiseTimeout(10).then(() => {
        // Adding data and context info to the url if any
        url = placeholders(self.ctx.data.url, {
          data: self.formValues,
          context: self.context,
          field: self.ctx
        });
      });
      let currentValue = self.value;
      let newChoicesValues;
      await self.select.setChoices(
        async () => {
          try {
            const response = await Axios.get(url);
            if (self.ctx.multiple === false) {
              // Placeholder for non multi select
              addEmptySelectOption(response.data);
            }
            newChoicesValues = response.data.map(item => item.value);
            return response.data;
          } catch (err) {
            // eslint-disable-next-line
            console.log(
              'Could not fetch data from url:',
              url,
              'for field:',
              self.ctx.key
            );
            return [];
          }
        },
        'value',
        'label',
        true
      );
      // if current value is not present in the newly loaded choices
      // current value sets to '' ;
      if (!newChoicesValues.includes(currentValue)) {
        currentValue = '';
      }
      self.select.setChoiceByValue(currentValue);
    },
    reset() {
      // this.initFieldValue();
    },
    dependentValueChanged(fieldKey, oldValue, newValue) {
      if (
        this.ctx.dataSrcDependentFields.includes(fieldKey) &&
        oldValue !== newValue
      ) {
        this.setChoices();
      }
    }
  },
  watch: {
    /**
     * To enable 2 way data binding for the custom select component
     * This is required for setting the default value and
     * changes the selected option when the value changes
     */
    value(value) {
      setTimeout(() => {
        this.select.setChoiceByValue(value);
      }, 0);
    }
  }
};
</script>
